<template>
<div class="v_ent_config">
  <el-card v-loading="loading">
    <div class="g-flex"  slot="header">
      <span>企业配置</span>
      <div class="g-flex-justify-end g-flex-1">
          <el-button size="medium" v-if="auth.save" type="success" @click="save()">保存配置</el-button>
      </div>
    </div> 

    <el-form :model="formData" label-width="120px" class="v-config-form">
      <el-row>
          <el-col :span="12">
              <el-form-item label="网站标题">
                  <el-input v-model="formData.title"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="手机号">
                  <el-input v-model="formData.mobile"></el-input>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
              <el-form-item label="联系qq">
                  <el-input v-model="formData.qq"></el-input>
              </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="联系微信">
                  <el-input v-model="formData.weixin"></el-input>
              </el-form-item>
          </el-col>
      </el-row>

       <el-row>
          <el-col :span="12">
              <el-form-item label="联系邮箱">
                  <el-input v-model="formData.email"></el-input>
              </el-form-item>
          </el-col>
            <el-col :span="12">
              <el-form-item label="超链接地址">
                  <div class="v-link-address g-flex-align-center">
                    <p>{{link}}</p>
                    <el-button @click="$copyText(link).then(()=>{$message.success('复制成功')},()=>{$message.error('浏览器不支持')})" size="mini" type="primary">复制</el-button>
                  </div>
              </el-form-item>
          </el-col>
      </el-row>

       <el-row>
          <el-col :span="12">
            <el-form-item label="发送文件">
              <el-tooltip :content="formData.send_file === '0' ? '关': '开'" placement="top"> <el-switch v-model="formData.send_file"  active-color="#13ce66" inactive-color="#dcdfe6" active-value="1" inactive-value="0"></el-switch>
            </el-tooltip>
            </el-form-item>
          </el-col>
         <el-col :span="12">
           <el-form-item label="通知提示音">
             <el-select v-model="AudioUrl" placeholder="请选择提示音" @change="changeAudio">
               <!-- 下拉选项列表 -->
               <el-option v-for="item in audioOptions" :key="item.url" :label="item.name" :value="item.url">
                 <span class="option-text">{{ item.name }}</span>
               </el-option>
             </el-select>
           </el-form-item>
         </el-col>
       </el-row>

      <div class="v-line"></div>

      <!--主题 插件代码 -->
      <el-row>
        <el-col :span="12" class="v-theme-select">
          <el-form-item label="主题风格"/>
          <el-row type="flex" justify="center">
            <el-col :span="10" v-for="(item, index) in imgList" :key="index">
              <div class="v-theme-img-item" @click="selectThemeClick(item)" :class="themeIndex === item.theme ? 'v-theme-active': ''">
                <el-image :src="item.url" alt=""/>
                <div class="v-theme-title g-flex-justify-center">{{item.title}}</div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12" class="v-daima">
          <el-form-item label="插件代码"/>
          <el-row type="flex" justify="center">
            <el-col :span="18">
              <el-input type="textarea" readonly v-model="plugin" resize="none" autosize></el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <div class="v-line"></div>

      <!-- 对话 -->
      <el-row>
        <el-col :span="12">
          <el-form-item label="对话开始" class="v-config-chat-start"><p>(每段对话开启时，系统将自动向顾客发送一段欢迎语)</p></el-form-item>
           <el-row>
             <el-col :span="20">
                <el-form-item label="企业欢迎消息">
                  <el-input v-model="formData.dialog_start"  resize="none" :autosize="{ minRows: 4, maxRows: 10}" type="textarea"></el-input>
                </el-form-item>
             </el-col>
           </el-row>
        </el-col>
        <el-col :span="12">
         <el-form-item label="留言" class="v-config-leave-msg">
            <p>
              (客户进行留言时，给的提示语)
            </p>
          </el-form-item>
          <el-row>
            <el-col :span="20">
              <el-form-item label="留言提示语">
                <el-input v-model="formData.dialog_leave_tip"  resize="none" :autosize="{ minRows: 4, maxRows: 10}" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- 留言提示 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="对话结束" class="v-config-chat-end">
            <p>
              (对话结束后，系统自动向顾客发送一段结束语)
            </p>
          </el-form-item>
          <el-row>
             <el-col :span="12">
                <el-form-item label="客服手动结束时">
                <el-input v-model="formData.dialog_end"  resize="none" :autosize="{ minRows: 4, maxRows: 10}" type="textarea"></el-input>
                </el-form-item>
             </el-col>
              <el-col :span="12">
                <el-form-item label="系统自动关闭时">
                  <el-input v-model="formData.dialog_end_kefu"  resize="none" :autosize="{ minRows: 4, maxRows: 10}" type="textarea"></el-input>
                </el-form-item>
             </el-col>
          </el-row>
        </el-col>

      </el-row>
    </el-form>
  </el-card>
</div>

</template>

<script>
  import { apiGetEntConfig, apiSaveEntConfig, apiGetLink } from '@/utils/api.js'
  import Bus from '@/utils/bus.js'
  export default {
    data() {
      return {
        auth: {
          save: this.$global.ApiList.includes(39)
        },
        loading: true,

        imgList: [
          { url: require('@/assets/img/theme_1.png'), theme: 1, title: 'mini' },
          { url: require('@/assets/img/theme_2.png'), theme: 2, title: '居中' },
        ],
        
        themeIndex: 1,
        
        link: '',

        plugin: '',

        formData: {},
        AudioUrl:localStorage.getItem('audio_url') ?? "/audio/msg.mp3",
        audioOptions: [
          {url: '/audio/msg.mp3', name: '消息提醒'},
          {url: '/audio/msg2.mp3', name: '灵动叮铃'},
          {url: '/audio/new-message.mp3', name: '冒泡声'}
        ],
      }
    },
    created() {
      this.apiGetLinkHandel()
      this.apiGetEntConfigHandel()
    },
    methods: {
      // 获取链接
      async apiGetLinkHandel() {
        const { success, data } = await apiGetLink()
        if(!success) return
        this.link = data.data
        this.plugin = data.plugin
      },
      changeAudio(audioUrl){
        // 1. 持久化缓存
        localStorage.setItem('audio_url', audioUrl);
        // 2. 气泡提示
        this.$message({
          message: '提示音已切换',
          type: 'success',
          duration: 1500
        });
        Bus.$emit('audioChanged', audioUrl);
      },
      // 获取配置
      async apiGetEntConfigHandel() {
        const { success, data } = await apiGetEntConfig()
        this.loading = false
        if(!success) return
        this.formData = data.data
        this.themeIndex = Number(data.data.theme_pc)
      },

      // 点击图片
      selectThemeClick(item) {
        this.formData.theme_pc = item.theme
        this.themeIndex = item.theme
      },
      
      // 保存企业配置
      async save() {
        this.loading = true
        const { success, data } = await apiSaveEntConfig(this.formData)
        this.loading = false
        if(!success) return
        this.$message.success(data.msg)
        this.apiGetEntConfigHandel()
      },
    }
  }
</script>

<style lang="scss">
.v_ent_config {
  padding: 12px;
  .v-line {
    margin: 20px 0;
    width: 100%;
    height: 2px;
    background: #F2F3F5;
  }
  .v-config-form {
    .v-link-address {
      p {
        padding-left: 15px;
        padding-right: 15px;
        color: $mainBlue;
      }
    }

    .v-theme-select {
      .v-theme-img-item {
        display: inline-block;
        cursor: pointer;
        padding: 6px;
        border-radius: 15px;
        &.v-theme-active {
          background: rgba($color: #000000, $alpha: 0.2);
          .v-theme-title {
            color: $white;
          }
        }
        .el-image {
          img {
            max-width: 200px;
            max-height: 200px;
            min-width: 100px;
            min-height: 100px;
            vertical-align: middle;
            object-fit: cover;
          }
        }
        .v-theme-title {
            padding-top: 20px; 
            color: $chatSeeHistoryColor;
            font-size: $small-more-font-size;
        }
      }
    }

    .v-daima {
      .el-textarea {
        .el-textarea__inner {
          background: #edf5fc;
        }
      }
    }

    .v-config-chat-start {
      color: $mainBlue;
      .el-form-item__label {
        color: $mainBlue;
      }
    }

    .v-config-chat-end {
      color: $red;
      .el-form-item__label {
        color: $red;
      }
    }

    .v-config-leave-msg {
      color: $purple;
      .el-form-item__label {
        color: $purple;
      }
    }
  }
}
</style>